import { hasOwnProperty } from "../object";

export const isErrorWithNestedMessage = (
  error: unknown
): error is { data: { message: string } } => {
  return Boolean(
    error &&
      typeof error === "object" &&
      hasOwnProperty(error, "data") &&
      error.data &&
      typeof error.data === "object" &&
      hasOwnProperty(error.data, "message") &&
      typeof error.data.message === "string"
  );
};

export const isErrorWithMessage = (
  error: unknown
): error is { message: string } => {
  return Boolean(
    error &&
      typeof error === "object" &&
      hasOwnProperty(error, "message") &&
      typeof error.message === "string"
  );
};

export const isErrorWithReason = (
  error: unknown
): error is { reason: string } => {
  return Boolean(
    error &&
      typeof error === "object" &&
      hasOwnProperty(error, "reason") &&
      typeof error.reason === "string" &&
      error.reason
  );
};

export const isOLDError = (error: unknown): error is { reason: "OLD" } =>
  isErrorWithReason(error) && error.reason === "OLD";

export const isRevertedWithoutReasonError = (
  error: unknown
): error is { data: "0x" } =>
  !!(
    error &&
    typeof error === "object" &&
    hasOwnProperty(error, "data") &&
    error.data === "0x"
  );

export const isTransactionReplacedError = (
  error: unknown
): error is { code: "TRANSACTION_REPLACED"; replacement: { wait: Function } } =>
  !!(
    error &&
    typeof error === "object" &&
    hasOwnProperty(error, "code") &&
    error.code === "TRANSACTION_REPLACED" &&
    hasOwnProperty(error, "replacement") &&
    error.replacement &&
    typeof error.replacement === "object" &&
    hasOwnProperty(error.replacement, "wait") &&
    typeof error.replacement.wait === "function"
  );

export const transactionRejectedError = {
  metamask: (error: unknown) =>
    Boolean(
      error &&
        typeof error === "object" &&
        hasOwnProperty(error, "code") &&
        (error.code === 4001 || error.code === "ACTION_REJECTED")
    ),
  walletconnect: (error: unknown) =>
    Boolean(
      error &&
        (error === "Failed or Rejected Request" ||
          (typeof error === "object" &&
            hasOwnProperty(error, "code") &&
            error.code === -32000))
    ),
  gnosis: (error: unknown) =>
    Boolean(
      error instanceof Error && error.message === "Transaction was rejected"
    ),
  is: (error: unknown): error is unknown =>
    transactionRejectedError.metamask(error) ||
    transactionRejectedError.walletconnect(error) ||
    transactionRejectedError.gnosis(error),
};

export const userRejectedRequestError = (
  error: unknown
): error is { name: "UserRejectedRequestError" } =>
  Boolean(
    error &&
      typeof error === "object" &&
      hasOwnProperty(error, "name") &&
      error.name === "UserRejectedRequestError"
  );

export const walletConnectionAlreadyPendingError = (
  error: unknown
): error is { code: -32002 } =>
  Boolean(
    error &&
      typeof error === "object" &&
      hasOwnProperty(error, "code") &&
      error.code === -32002
  );
